import { NewGame } from '../c/GameParams';
export default NewGame;



// WEBPACK FOOTER //
// ./src/p/NewGame.js